// @flow

const omit = (obj: Object, keys: string[]) =>
  obj &&
  Object.fromEntries(Object.entries(obj).filter(([k]) => !keys.includes(k)));

export default omit;
